import { useState, useEffect } from 'react';
import { TrendingUp, X, Users, Star } from 'lucide-react';

const notifications = [
  { name: 'Mike T.', location: 'Texas', action: 'just joined the free picks chat', icon: 'users' },
  { name: 'Sarah K.', location: 'Florida', action: 'signed up for VIP', icon: 'star' },
  { name: 'James R.', location: 'California', action: 'just joined the free picks chat', icon: 'users' },
  { name: 'David M.', location: 'New York', action: 'is viewing today\'s picks', icon: 'trending' },
  { name: 'Chris P.', location: 'Ohio', action: 'just signed up', icon: 'users' },
  { name: 'Amanda L.', location: 'Georgia', action: 'signed up for VIP', icon: 'star' },
  { name: 'Tyler B.', location: 'Arizona', action: 'just joined the free picks chat', icon: 'users' },
  { name: 'Kevin W.', location: 'Nevada', action: 'is viewing today\'s picks', icon: 'trending' },
];

export const SocialProof = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Check if user dismissed notifications this session
    if (sessionStorage.getItem('psl_social_dismissed')) {
      setIsDismissed(true);
      return;
    }

    // Show first notification after 15 seconds
    const initialDelay = setTimeout(() => {
      setIsVisible(true);
    }, 15000);

    return () => clearTimeout(initialDelay);
  }, []);

  useEffect(() => {
    if (isDismissed) return;

    // Cycle through notifications every 30 seconds (reduced frequency)
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % notifications.length);
        setIsVisible(true);
      }, 500);
    }, 30000);

    // Hide after 5 seconds
    const hideTimeout = setTimeout(() => {
      setIsVisible(false);
    }, 5000);

    return () => {
      clearInterval(interval);
      clearTimeout(hideTimeout);
    };
  }, [currentIndex, isDismissed]);

  const handleDismiss = () => {
    setIsDismissed(true);
    setIsVisible(false);
    sessionStorage.setItem('psl_social_dismissed', 'true');
  };

  if (isDismissed || !isVisible) return null;

  const notification = notifications[currentIndex];
  
  const getIcon = () => {
    switch(notification.icon) {
      case 'star': return <Star className="text-accent" size={18} />;
      case 'users': return <Users className="text-primary" size={18} />;
      default: return <TrendingUp className="text-accent" size={18} />;
    }
  };

  return (
    <div 
      className="fixed bottom-4 left-4 z-40 bg-card border border-border shadow-lg shadow-black/30 p-4 max-w-xs animate-slideIn"
      data-testid="social-proof"
    >
      <button
        onClick={handleDismiss}
        className="absolute top-2 right-2 text-muted-foreground hover:text-white transition-colors"
        data-testid="dismiss-social"
      >
        <X size={14} />
      </button>
      
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 bg-accent/20 rounded-full flex items-center justify-center flex-shrink-0">
          {getIcon()}
        </div>
        <div className="flex-1 pr-4">
          <p className="text-sm font-medium text-white">
            <span className="font-bold">{notification.name}</span>
            <span className="text-muted-foreground"> from {notification.location}</span>
          </p>
          <p className="text-sm text-accent font-bold">
            {notification.action}
          </p>
          <p className="text-xs text-muted-foreground mt-1">Just now</p>
        </div>
      </div>
    </div>
  );
};
